export default __webpack_public_path__ + "static/media/loginBG.1fc58679.jpg";